var module = angular.module('octopusApp.projects');

module.directive('variableMapping', function($timeout, octopusLog) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/docker_run/variable-mapping.html',
        scope: {
            action: '=',
            project: '=',
            localNames: '='
        },
        link: function($scope, $element) {
            //$scope.$element = $element;
        },
        controller: function() {
            var vm = this;

            vm.newValue = "";
            vm.newVariable = "";
            vm.addVariable = addVariable;
            vm.removeVariable = removeVariable;
            vm.variableMappings = [];

            function removeVariable(variable){
                var idx = vm.variableMappings.indexOf(variable);
                if (idx >= 0) {
                    vm.variableMappings.splice(idx, 1);
                }
                setProperties();
            }

            function addVariable() {
                if (_.any(vm.variableMappings, function (mapping) {
                        return mapping.variable === vm.newVariable;
                    })) {
                    octopusLog.log("Mapping to that container port already exists.. Try again");
                    return;
                }

                var pm = new VariableMapping(vm.newVariable, vm.newValue, true);
                vm.variableMappings.push(pm);
                vm.newValue = "";
                vm.newVariable = "";
                pm.commitEdit();
            }

            function VariableMapping(variable, value) {
                var self = {
                    variable: variable,
                    editVariable: variable,
                    value: value,
                    editValue: value,
                    isEditing: false
                };

                self.formatted = formatMapping();
                self.commitEdit = commitEdit;
                self.cancelEdit = cancelEdit;

                function cancelEdit() {
                    self.editVariable = self.variable;
                    self.editValue = self.value;
                    self.isEditing = false;
                }

                function commitEdit(){
                    self.variable = self.editVariable;
                    self.value = self.editValue;
                    self.isEditing = false;
                    self.formatted = formatMapping();
                    setProperties();
                }

                function formatMapping(){

                    return self.variable +" = \"" + self.value + "\"";
                }
                return self;
            }

            function setProperties() {
                vm.action.Properties["Octopus.Action.Docker.EnvVariable"] =  JSON.stringify(vm.variableMappings.reduce(function(obj, mapping) {
                    obj[mapping.variable] = mapping.value;
                    return obj;
                }, {}));
            }

            function init() {
                var json = vm.action.Properties["Octopus.Action.Docker.EnvVariable"];
                if (!!json) {
                    try {
                        var obj = JSON.parse(json);
                        vm.variableMappings = _.map(obj, function (value, name) {
                            return new VariableMapping(name, value);
                        });

                    } catch (err) {
                        console.error(err);
                    }
                }
            }

            init();
        },
        controllerAs: 'vm',
        bindToController: true
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/variable-mapping.js
// module id = 1362810652878272
// module chunks = 1